module.exports = __webpack_public_path__ + "img/elementheights_jas.64cd56dc.png";